import { Component, Input, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeOutAnimation } from '../_animations/fade-out.animation';
import { OtpKontaktinfo, OtpKontaktinfoPost } from '../interfaces/otpKontaktinfo.interface';
import { AuthService } from './../auth/auth.service';

@Component({
  selector: 'ngbd-otp-modal',
  template: `
  <div class="modal-header">
    <div class="modal-title">
      <fa-icon [icon]="['fas', 'envelope']" class="mr-2"></fa-icon>{{ 'label.valj-vart-koden-skickas' | translate }}
    </div>
  </div>
    <div class="modal-body">
      <div *ngFor="let item of kontaktinfos.epostadresser" class="form-check">
        <label class="form-check-label mb-2">
          <input type="radio" class="form-check-input" name="radio" [checked]="selected?.id === item.id" (change)="setSelection(item)"><span [innerHTML]="'label.epost-till' | translate:{ recipient: item.visning } | safehtml"></span>
        </label>
      </div>
      <div *ngFor="let item of kontaktinfos.telefonnummer" class="form-check">
        <label class="form-check-label mb-2">
          <input type="radio" class="form-check-input" name="radio" [checked]="selected?.id === item.id" (change)="setSelection(item)"><span [innerHTML]="'label.sms-till' | translate:{ recipient: item.visning } | safehtml"></span>
        </label>
      </div>
    </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-modal" (click)="ok()" [disabled]="!selected">{{ 'button.skicka' | translate }}</button>
    <button type="button" class="btn btn-danger btn-modal" (click)="cancel()">{{ 'button.avbryt' | translate }}</button>
  </div>`,
  styles: [`
    .form-check {
      margin-top: 1rem;
      margin-bottom: 1rem;
      margin-left: 2rem;
    }
    .form-check-input {
      width: 1.5rem;
      height: 1.5rem;
      margin-top: 0;
      margin-left: -2.25rem;
      accent-color: #ff87a8;
    }`],
  animations: [
    fadeOutAnimation
  ]
})
export class NgbdOtpModal {
  private _kontaktinfos: OtpKontaktinfo
  @Input() set kontaktinfos(value: OtpKontaktinfo) {
    if (value.epostadresser) {
      this.setSelection(value.epostadresser[0]);
    } else if (value.telefonnummer) {
      this.setSelection(value.telefonnummer[0]);
    }
    this._kontaktinfos = value;
  } get kontaktinfos() { return this._kontaktinfos; };
  public selected: OtpKontaktinfoPost;

  constructor(
    public activeModal: NgbActiveModal,
    public auth: AuthService) {
  }

  public setSelection(selected: OtpKontaktinfoPost) {
    this.selected = selected;
  }

  public ok(): void {
    this.activeModal.close(this.selected.id);
  }

  public cancel(): void {
    this.activeModal.close();
  }
}
